import { createContext } from 'preact';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from 'src/common/types';

import createUserStore, { UserStoreProps } from './userstore';
import createPromoStore from './promostore';
import createLayoutStore from './layoutstore';
import createConfigStore from './configstore';

const data = (window as any).__APPDATA__;

let user: UserStoreProps = {
    ...data.user,
};

if (data.user.token) {
    const decoded: DecodedToken = jwtDecode(data.user.token);
    user = {
        ...data.user,
        userID: decoded.user.id,
        userTypeID: decoded.user.type,
        screenName: decoded.user.name,
        profileUrl: decoded.user.profile_url,
        isLoggedIn: decoded.user.is_logged_in,
        isStudioMember: decoded.user.is_studio_member,
        isStudioOwner: decoded.user.is_studio_owner,
    };
}

function createAppStore() {
    return {
        user: createUserStore(user),
        promo: createPromoStore(data.promo),
        config: createConfigStore(data.config),
        layout: createLayoutStore(),
    };
}

const store = createAppStore();
const context = createContext(store);

export { context, store, createAppStore };
